import { Component, OnInit, PLATFORM_ID, APP_ID, Inject, Optional } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AuthService, DOMAIN, EventService, PWAService } from '@clooper/core';
import { SharedModule } from "./shared/shared.module";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(APP_ID) public appId: string,
    private auth: AuthService,
    @Optional() private events: EventService,
    private router: Router,
    private pwaService: PWAService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.disableAutoZoomIos()
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.auth.domain = DOMAIN.PUBLIC;
    if (this.isBrowser) {
      this.pwaService.check();
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          scroll({
            top: 0,
            behavior: 'smooth'
          });
        }
      })
      this.auth.validate().then(() => this.router.navigate(['/login']));
      this.events.listen();
    }
  }

  disableAutoZoomIos() {
    let iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (iOS && document?.head?.querySelector('meta[name="viewport"]')?.getAttribute('content'))
      document?.head?.querySelector('meta[name="viewport"]')?.setAttribute('content', "width=device-width, initial-scale=1, maximum-scale=1");
    else
      document?.head?.querySelector('meta[name="viewport"]')?.setAttribute('content', "width=device-width, initial-scale=1");
  }

}
